// extracted by mini-css-extract-plugin
module.exports = {"root":"Home_root__2lrj7","title":"Home_title__2wfN0","blocks":"Home_blocks__3QVaT","block":"Home_block__2zoDS"};